import { del } from "../methods";
function deletePortfolio(id, headers = {}) {
  return del({
    url: `api/user/portfolio/${id}`,
    headers
    // requiresAuthentication: true,
  });
}
export {
  deletePortfolio as default
};
